/**
 * Hotfix 203.3.3 — Escala global de z-index (capas de UI).
 * ÚNICA fuente de verdad para overlays globales. Documentación completa
 * en /app/memory/Z_INDEX_SCALE.md.
 *
 * Escala adoptada:
 *   0–49    contenido base (z-10/20/30/40 locales dentro de stacking
 *           contexts propios — p.ej. FloatingGifts dentro del frame del
 *           Post/Reel — NO compiten globalmente)
 *   50–99   elementos flotantes dentro del contenido (banners de upload,
 *           headers auto-hide, FAB crear)
 *   100–139 viewers fullscreen (MediaBubble 100, CameraCapture 110,
 *           Reels 120, Stories 120)
 *   140–179 Drops y overlays interactivos SOBRE viewers
 *   180–229 sheets, comentarios, opciones y menús
 *   230–269 confirmaciones y modales críticos
 *   270–299 celebraciones globales (toasts de sonner usan su propio
 *           z-index interno altísimo — siempre visibles, no bloquean)
 *   300+    reservado a excepciones — NINGUNA en uso (la excepción legacy
 *           de Booking z-[10000] fue eliminada en Hotfix 203.3.4; el badge
 *           "Made with Emergent" del preview es un elemento EXTERNO al
 *           bundle, no controlado por LBW y ausente en producción)
 *
 * Uso: className={`fixed inset-0 ${Z.SHEET} ...`}
 * Las clases son literales para que Tailwind JIT las genere.
 */
export const Z = {
  CONTENT: 'z-10',
  FLOATING_CONTENT: 'z-[60]',
  VIEWER: 'z-[120]',
  DROP_LAYER: 'z-[150]',
  SHEET: 'z-[200]',
  MODAL: 'z-[230]',
  CELEBRATION: 'z-[280]',
  CELEBRATION_TOP: 'z-[281]',
};
